import { createContext, useContext } from 'react';
import { Map } from 'maplibre-gl';

export const MapContext = createContext<Map | null>(null);

export const useMapContext = () => {
  return useContext(MapContext);
};
